.mainCard h3 {
  font:
    normal normal 600 1.125rem/1.375rem Rubik,
    sans-serif;
}

.mainCard div {
  font:
    normal normal bold 4.375rem/5.1875rem Rubik,
    sans-serif;
}

.statsCard h3 {
  font:
    normal normal 300 1.125rem/1.5rem Roboto,
    sans-serif;
}

.statsCard div {
  font:
    normal normal bold 2.1875rem/2.625rem Rubik,
    sans-serif;
}
